/************
 Swipers
 ************/

// thumbnails mobile
let productV19ThumbnailImages = new Swiper("#productV19ThumbnailsSwiper", {
    slidesPerView: "auto",
    spaceBetween: 5,
    breakpoints: {
        800: {
            slidesPerView: 6,
        }
    },
    loop: true,
    navigation: {
        nextEl: '#productV19ThumbnailsNext',
        prevEl: '#productV19ThumbnailsPrev',
    },
});

// main swiper
let productV19Images = new Swiper("#productV19Swiper", {
    navigation: {
        nextEl: '#productV19Swiper .swiper-button-next',
        prevEl: '#productV19Swiper .swiper-button-prev',
    },
    loop: true,
    thumbs: {
        swiper: productV19ThumbnailImages
    }
});

// gallery desktop
document.querySelectorAll(".productV19GalleryItem").forEach(function (element) {
    element.addEventListener("click", function () {
        // determine index
        let index = getElIndex(this);

        // change active slide
        productV19Images.slideTo(index);
    });
});

/********************
 Video Popup
 *******************/

// open video
document.querySelectorAll('.productV19Video')?.forEach(function (element) {
    element.addEventListener("click", function (e) {
        e.preventDefault();
        const popup = document.querySelector(".videoPopup");
        popup.showModal();
        popup.querySelector("video").play();
    })
})


/*****************
 Reviews
 ****************/

document.querySelector("#productV19Review")?.addEventListener("click", function () {
    window.scrollTo({
        top: document.querySelector("#looxReviews").offsetTop - 100,
        behavior: "smooth"
    });
})


/**************
 Function To Update Pricing
 ***************/

// update active variant
function updateProductV16(skipImage = false) {

    // check for an active color swatch
    activeVariant = product.variants.filter((variant) => {
        return variant.id === parseInt(document.querySelector(".productV19FormGroupFlexColor:checked").value)
    })[0];

    // find variant image
    if (!skipImage) {
        if (activeVariant.featured_image) {
            const variantImage = document.querySelector(`.productV19SwiperSlide[id="${activeVariant.featured_image.id}"]`);
            if (variantImage) {
                productV19Images.slideTo(getElIndex(variantImage));
            }
        }
    }

    // in the variant available?
    let isAvailable = activeVariant.available;

    // check if the variant is in stock
    if (isAvailable) {
        document.querySelector("#productV19ATC").classList.remove("oos");
        document.querySelector("#productV19ATC").textContent = `Add To Cart`;
    } else {
        document.querySelector("#productV19ATC").classList.add("oos");
        document.querySelector("#productV19ATC").textContent = "Sold Out — Notify Me When Available";
    }
}

updateProductV16(true)

/*******************
 Product Form (Default and Group)
 ********************/

// color swatch support on change
document.querySelectorAll(".productV19FormGroupFlexColor").forEach(function (element) {
    element.addEventListener("change", function () {
        // update label
        this.parentElement.parentElement.parentElement.querySelector(".productV19FormGroupHeaderLabel").innerHTML = this.getAttribute("aria-label");

        // update price
        updateProductV16();
    });
});


// variant dropdown support on change
document.querySelector("#productV19FormVariants")?.addEventListener("change", updateProductV16);


/****************
 *  Quantity
 *************/

let quantity = 1;


/**************
 Product ATC
 ***************/

// add to cart button
document.querySelector("#productV19ATC").addEventListener("click", async function (e) {
    e.preventDefault();

    // check for out of stock
    if (this.classList.contains("oos")) {
        // check email
        let {value: email} = await Swal.fire({
            title: product.title,
            text: "Enter your email to be notified when this product is back in stock.",
            input: "email",
            inputPlaceholder: "Email Address",
            confirmButtonText: "Notify Me When Available",
        });

        // confirm email is returned
        if (!email) {
            return;
        }

        // add to waitlist
        let formData = new FormData();
        formData.append("a", await klaviyo.account());
        formData.append("email", email);
        formData.append("g", "");
        formData.append("variant", activeVariant.id);
        formData.append("product", product.id);
        formData.append("platform", "shopify");
        formData.append("subscribe_for_newsletter", false);
        fetch("https://a.klaviyo.com/onsite/components/back-in-stock/subscribe", {
            method: "POST",
            body: formData
        })

        // show success message
        await Swal.fire({
            title: "Success!",
            text: "You will be notified when this product is back in stock.",
            confirmButtonText: "OK",
        });

        return;
    }

    // add loading animation
    this.classList.add("loading");

    // create form data
    let formData = {
        items: []
    };


    // normal product
    formData.items.push({
        quantity: quantity,
        id: activeVariant.id,
    });


    // reverse form data
    formData.items.reverse();

    // check if we should go directly to checkout
    if (this.classList.contains('checkout')) {

        // clear cart
        await clearCart();

        // add gift free gift
        // formData.items.push(
        //     {
        //         quantity: 1,
        //         id: 49838321369368
        //     }
        // )
        await addProduct(formData)

        window.location.href = '/checkout';

        // klaviyo tracking
        try {
            _learnq.push(['track', 'Added to Cart', item]);
        } catch (error) {
            console.error("Klaviyo tracking not found");
        }

        return;
    }

    // add productV19
    await addProduct(formData);

    // klaviyo tracking
    try {
        _learnq.push(['track', 'Added to Cart', item]);
    } catch (error) {
        console.error("Klaviyo tracking not found");
    }

    // remove loading animation
    this.classList.remove("loading");

    // open cart
    await openCart();
});


// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // click normal atc
        document.querySelector("#productV19ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

// atc call to action
document.querySelectorAll(`.button[href="#add_to_cart_addon"]`).forEach(function (element) {
    element.addEventListener("click", async function (e) {
        e.preventDefault();

        // check the addon if not already checked
        if (!document.querySelector("#productV19AddonCheckboxInput").checked) {
            document.querySelector("#productV19AddonCheckbox").click();
        }


        // click normal atc
        document.querySelector("#productV19ATC").click();

        // start/stop loading
        this.classList.add("loading");
        await sleep(1000);
        this.classList.remove("loading");
    });
});

/**************
 Sticky ATC
 ***************/

const stickyAtcObserver = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
        if (entry.isIntersecting) {
            document.querySelector("#productV19ATC").classList.remove("sticky");
        } else {
            document.querySelector("#productV19ATC").classList.add("sticky");
        }
    });
}, {
    rootMargin: "-100px 0px 0px 0px"
})

stickyAtcObserver.observe(document.querySelector("#productV19Content"));

// event listeners for dropdown items
document.querySelectorAll(`.productV19DropdownTop`).forEach(function (element) {
    element.addEventListener("click", function () {
        this.parentElement.classList.toggle("active");
    });
});